import React__default from 'react';
import { ArticleRelation } from './article-relation.esm.js';

var ArticleRelations = function ArticleRelations(props) {
  var relations = props.relations;
  var articleRelationsList = relations.map(function (relation, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index,
      className: "py-2"
    }, /*#__PURE__*/React__default.createElement(ArticleRelation, {
      relation: relation
    }));
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "px-4"
  }, /*#__PURE__*/React__default.createElement("ul", null, articleRelationsList));
};

export { ArticleRelations };
//# sourceMappingURL=article-relations.esm.js.map
